import React from "react";
import { numberWithCommas } from "../../../helpers/dataHelpers";

import { useTable } from "react-table";
import {
  ButtonToolbar,
  Dropdown,
  DropdownButton,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import _ from "lodash";

import {
  ProfitBreakdownExcelToRenderOverallComponent,
  ProfitBreakdownExcelToRenderAreaComponent,
  ProfitBreakdownExcelToRenderBranchComponent,
} from "./ProfitBreakdownExcelToRenderComponent";

const onHandlePrint = (props) => {
  let { searchBy, filename } = props.data;

  var prtContent = document.querySelector(`.active #${searchBy}-printTable`);
  var WinPrint = window.open(
    "",
    "",
    "left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0"
  );
  WinPrint.document.write(
    `<html><head><title>${filename}</title>
     <link rel="stylesheet" type="text/css" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css" >
     <style type="text/css" media="print">
      @page { size: landscape; }
    </style>
    </head><body>`
  );

  WinPrint.document.write(prtContent.innerHTML);
  WinPrint.document.write(
    '<script type="text/javascript">window.print();window.close();</script>'
  );

  WinPrint.document.write("</body></html>");
  WinPrint.document.close();
};

const renderPrintableExcelComponent = (props) => {
  let { searchBy, list, filename } = props.data;

  switch (searchBy) {
    case "All":
      return ProfitBreakdownExcelToRenderOverallComponent(list, filename);

    case "Area":
      return ProfitBreakdownExcelToRenderAreaComponent(list, filename);

    case "Branch":
      return ProfitBreakdownExcelToRenderBranchComponent(list, filename);

    default:
      return "No Value";
  }
};

const totalComputation = (func, className) => {
  var merged = [].concat.apply([], func);

  var colums = _.chain(merged)
    .groupBy("name")
    .map((x) => ({
      name: x.name,
      amount: _.sumBy(x, "amount"),
    }))
    .value();

  return colums.map((item, idx) => {
    return (
      <td className={className} key={idx}>
        <span className="float-right">{numberWithCommas(item.amount, 2)}</span>
      </td>
    );
  });
};

const renderTotalRow = (props) => {
  return (
    <tr className="text-success">
      <td colSpan={props.data.searchBy === "Branch" ? "2" : "1"}>
        <span className="float-center">TOTAL</span>
      </td>
      {/* <td>
        <span>
          {numberWithCommas(
            props.data.list.reduce(
              (total, summary) => total + summary.branchCount,
              0
            )
          )}
        </span>
      </td> */}

      {totalComputation(
        props.data.list.map((x) => x.newPawnDetails.charges),
        "newPawns"
      )}
      {totalComputation(
        props.data.list.map((x) => x.newPawnDetails.discounts),
        "newPawns"
      )}
      {totalComputation(
        props.data.list.map((x) => x.redeemedDetails.charges),
        "redeemedPawns"
      )}
      {totalComputation(
        props.data.list.map((x) => x.redeemedDetails.discounts),
        "redeemedPawns"
      )}

      <td>
        <span className="strong float-right">
          {numberWithCommas(
            props.data.list.reduce(
              (total, summary) => total + summary.newPawnDetails.profit,
              0
            ),
            2
          )}
        </span>
      </td>

      <td>
        <span className="strong float-right">
          {numberWithCommas(
            props.data.list.reduce(
              (total, summary) => total + summary.redeemedDetails.profit,
              0
            ),
            2
          )}
        </span>
      </td>

      <td>
        <span className="strong float-right">
          {numberWithCommas(
            props.data.list.reduce(
              (total, summary) => total + summary.totalProfit,
              0
            ),
            2
          )}
        </span>
      </td>
    </tr>
  );
};

// Create a default prop getter
const defaultPropGetter = () => ({});

function ProfitBreakdownViewer(props) {
  const {
    getTableProps,
    getTableBodyProps,
    getHeaderProps = defaultPropGetter,
    getColumnProps = defaultPropGetter,
    getCellProps = defaultPropGetter,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns: props.column,
    data: props.data.list,
  });
  let { searchBy } = props.data;

  return (
    <Container fluid>
      <Row>
        <Col>
          <ButtonToolbar className="mt-3 float-left">
            <DropdownButton
              size="md"
              className="m-1"
              variant="primary"
              title={<FontAwesomeIcon icon={faPrint} />}
            >
              <Dropdown.Item
                onClick={() => {
                  onHandlePrint(props);
                }}
              >
                Pdf
              </Dropdown.Item>

              {renderPrintableExcelComponent(props)}
            </DropdownButton>
          </ButtonToolbar>
        </Col>
      </Row>

      <Row>
        <Col>
          <div id={`${searchBy}-printTable`}>
            <table className="custom-table " {...getTableProps()}>
              <thead>
                {headerGroups.map((headerGroup, key) => (
                  <tr {...headerGroup.getHeaderGroupProps()} key={key}>
                    {headerGroup.headers.map((column, key) => (
                      <th
                        key={key}
                        {...column.getHeaderProps([
                          {
                            className: column.className,
                            style: column.style,
                          },
                          getColumnProps(column),
                          getHeaderProps(column),
                        ])}
                      >
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr key={i} {...row.getRowProps()}>
                      {row.cells.map((cell, key) => {
                        return (
                          <td
                            key={key}
                            {...cell.getCellProps([
                              {
                                className: cell.column.className,
                                style: cell.column.style,
                              },
                              getColumnProps(cell.column),
                              getCellProps(cell),
                            ])}
                          >
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
                {renderTotalRow(props)}
              </tbody>
              {/* <tfoot>
                {footerGroups.map((group) => (
                  <tr {...group.getFooterGroupProps()}>
                    {group.headers.map((column) => (
                      <td {...column.getFooterProps()}>
                        {column.render("Footer")}
                      </td>
                    ))}
                  </tr>
                ))}
              </tfoot> */}
            </table>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default ProfitBreakdownViewer;
